import { mergeUiMessages } from '@erebus/ui/i18n';
import english from './en-US/en.json';
import french from './fr-CA/fr.json';
import rmiEnglish from './RMI/en-US/en.json';
import rmiFrench from './RMI/fr-CA/fr.json';

// mergeUiMessages layers @erebus/ui's own `ui.*` text underneath ours, so the
// shared components have wording without Connect restating it. Our keys win,
// so any shared string can be reworded here.
//
// It only writes into en-US and fr-CA. The -rmi locales inherit `ui.*` from
// their base locale, because vue-i18n resolves a missing key by walking the
// locale up a subtag at a time (en-US-rmi -> en-US -> en) — the same reason
// the -rmi bundles only need to hold the strings RMI actually changes.
export default mergeUiMessages({
  'en-US': english,
  'fr-CA': french,
  'en-US-rmi': rmiEnglish,
  'fr-CA-rmi': rmiFrench,
});
